<template>
    <div class="provider-logo-container" v-if="product.disabled || product.providerSlug === 'anwb-energie'">
        <img :src="product.provider_logo" v-bind="imageAttributes" />
    </div>
    <button v-else-if="product.orderline" v-bind="dataAttributes" class="clean-button provider-logo-container" @click="handleClick">
        <img :src="product.provider_logo" v-bind="imageAttributes" />
    </button>
    <a v-else :href="clickoutUrl" v-bind="dataAttributes" class="provider-logo-container" rel="nofollow" target="_blank"
        @click="handleClick">
        <img :src="product.provider_logo" v-bind="imageAttributes" />
    </a>
</template>

<script setup>
import { computed, toRef } from 'vue';
import { useProductClick } from '../../composables/useProductClick';


const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
    label: {
        type: String,
        default: 'Aanvragen'
    }
});

const imageAttributes = computed(() => {
    return {
        src: props.product.provider_logo,
        alt: props.product.provider_name + ' logo',
        class: 'provider-logo',
        width: 85,
    };
});

const productRef = toRef(props, 'product');

const { handleClick, dataAttributes, clickoutUrl } = useProductClick(props.product);


</script>
